import Vue from 'vue';
import { mask } from 'vue-the-mask';
import ApiRequest from '@/tools/ApiRequest';
import formValidationRules from '@/tools/validationRules/formValidationRules';
import InvoiceForm from '@/tools/models/InvoiceForm';
import Product from '@/tools/models/Product';
import textFieldDefaultProps from '@/tools/helpers/textFieldDefaultProps';
import TMAlert from '@/tools/models/TMAlert';
import DistributorAutocomplete from '@/components/DistributorAutocomplete/DistributorAutocomplete.vue';
import ProductList from '@/components/ProductList/ProductList.vue';
import RequestException from '@/tools/helpers/RequestException';

export default Vue.extend({
  name: 'invoices',
  components: {
    'fan-product-list': ProductList,
    'fan-distributor-autocomplete': DistributorAutocomplete,
  },
  directives: {
    mask,
  },
  data: () => ({
    loaded: false,
    textFieldProps: textFieldDefaultProps,
    isFormValid: false,
    productListFlexSize: '1px',
    formData: new InvoiceForm(),
    invoicePhoto: [] as any,
    validationRules: formValidationRules,
  }),
  computed: {
    form(): Vue & { validate: () => boolean; resetValidation: () => void } {
      return this.$refs.invoiceRegisterForm as Vue & {
        validate: () => boolean;
        resetValidation: () => void;
      };
    },
    productList(): Vue & { getSelectedProducts: () => Product[] } {
      return this.$refs.productList as Vue & { getSelectedProducts: () => Product[] };
    },
    distributorSelect(): Vue & { getSelectedDistributor: () => number } {
      return this.$refs.distributor as Vue & { getSelectedDistributor: () => number };
    },
  },
  methods: {
    submitInvoice(): void {
      this.formData.items = this.productList.getSelectedProducts();
      this.formData.distributor_id = this.distributorSelect.getSelectedDistributor();

      if (this.formData.items.length === 0) {
        this.$store.dispatch(
          'setAlert',
          new TMAlert({
            title: 'Preencha os campos corretamente',
            message: 'É necessário ao menos 1 produto registrado na nota.',
            state: true,
          }),
        );
      } else if (this.form.validate()) {
        ApiRequest.registerInvoice(this.formData)
          .then((response) => {
            const id = response.data.id;
            this.uploadPhoto(id);
          })
          .catch((error) => new RequestException(error, this.$store, this.$router));
      }
    },
    uploadPhoto(id: number): void {
      const photoData = new FormData();
      photoData.append('image', this.invoicePhoto);

      ApiRequest.uploadInvoicePhoto(id, photoData)
        .then((response) => {
          this.$store.dispatch(
            'setAlert',
            new TMAlert({
              title: 'Sucesso',
              message: 'Nota cadastrada com sucesso',
              state: true,
            }),
          );

          this.$router.push('/');
        })
        .catch((error) => new RequestException(error, this.$store, this.$router));
    },
    cancel(): void {
      this.$router.push('/');
    },
    setLoaded(): void {
      if (!this.loaded) {
        this.loaded = true;
      }
    },
  },
});
